emergence.init({
    container: window,
    reset: false,
    handheld: true,
    throttle: 250,
    elemCushion: 0.15,
    offsetTop: 0,
    offsetRight: 0,
    offsetBottom: 0,
    offsetLeft: 0,
  });